import { IapParams } from 'utils/iapParamValidation';

export const incrementParamsForUI = (params: IapParams) => ({
  ...params,
  phase: params.phase !== undefined ? params.phase + 1 : 1,
});

export const decrementedParamsForCode = (params: IapParams) => ({
  ...params,
  phase: params.phase !== undefined ? params.phase - 1 : 0,
});
